export default __webpack_public_path__ + "static/media/Grupo6138.efe45f55.svg";